import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  notification,
  Row,
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../config/api";
import { GET, PUT } from "../../utils/apicalls";
import moment from "moment";

function UpdateMonthlyReport() {
  const [isLoading, setIsLoading] = useState(false);
  const [MonthlyPlannerData, setMonthlyPlannerData] = useState<any>({});
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  useEffect(() => {
    getMonthlyPlannerData();
  }, []);

  const getMonthlyPlannerData = async () => {
    try {
      const api = `${API.GET_ONE_MONTHLY_REPORT}${id}`;
      const response: any = await GET(api, {});
      setMonthlyPlannerData(response?.data || {});
      form.setFieldsValue({
        ...response?.data,
        date: response?.data?.date ? moment(response?.data.date) : null, // Convert date string to moment object
      });
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  const submitHandler = async (values: any) => {
    try {
      // Validate and format date
      const formattedDate = values.date
        ? moment.isMoment(values.date)
          ? values.date.format("YYYY-MM-DD")
          : null
        : null;

      let obj = {
        clientId: MonthlyPlannerData.clientId,
        date: values.date,
        impression: Number(values.impression),
        leads: Number(values.leads),
        campaignsContent: values.campaignsContent,
        celebrationDays: values.celebrationDays,
        posterContent: values.posterContent,
        amount: Number(values.amount),
        status: values.status,
      };

      setIsLoading(true);
      const api = API.UPDATE_MONTHLY_REPORT + id;
      const postRequest: any = await PUT(api, obj);

      if (postRequest) {
        notification.success({ message: "Planner updated successfully!" });
        form.resetFields();
      } else {
        notification.error({ message: "Something went wrong" });
      }
      navigate(-1);
    } catch (error) {
      console.error("Error while updating the planner:", error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Card>
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="posterContent"
                label="posterContent"
                rules={[{ required: true, message: "Enter posterContent" }]}
              >
                <Input placeholder="posterContent" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="celebrationDays"
                label="celebrationDays"
                rules={[{ required: true, message: "Enter celebrationDays" }]}
              >
                <Input placeholder="celebrationDays" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="campaignsContent"
                label="campaignsContent"
                rules={[{ required: true, message: "Enter campaignsContent" }]}
              >
                <Input placeholder="campaignsContent" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="impression"
                label="impression"
                rules={[{ required: true, message: "Enter impression" }]}
              >
                <Input placeholder="impression" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="leads"
                label="leads"
                rules={[{ required: true, message: "Enter leads" }]}
              >
                <Input placeholder="leads" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="amount"
                label="amount"
                rules={[{ required: true, message: "Enter amount" }]}
              >
                <Input placeholder="amount" />
              </Form.Item>
            </Col>
            <Col sm={6}>
              <Form.Item
                name="status"
                label="status"
                rules={[{ required: true, message: "Enter status" }]}
              >
                <Input placeholder="status" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="date"
                label="Date"
                rules={[{ required: true, message: "Select date" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Update Planner
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default UpdateMonthlyReport;
